import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, DetailValue, FixedDropDownButton, Icon, Loader, modal, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
import StavObjednavka from "./StavObjednavka";
import {formatDateTime} from "../utils/utils";
import * as objednavkaActions from "../actions/objednavkaActions";
import * as EnumStavObjednavka from "../api/gen/cgo/EnumStavObjednavka";
import * as EnumStavObjednavkaInfo from "../api/EnumStavObjednavkaInfo";
import * as ciselnikActions from "../actions/ciselnikActions";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
import * as opravneniActions from "../actions/opravneniActions";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující základní informace o objednávce a umožňující akce s objednávkou.
 */
class ZakladniInformacePanel extends Component<WithTranslation> {

    static propTypes = {
        objednavka: PropTypes.object.isRequired, // VO objednávky
        objednavkaRights: PropTypes.object.isRequired, // VO oprávnění na objednávku
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(ciselnikActions.fetchPobockyIfNeeded());
    };

    handleTiskObjednavky = (objednavka) => {
        window.open(`${serverContextPath}/api/cgo/objednavka/${objednavka.id}/tiskZakazka`, "_blank");
    };

    handleTiskKalkulace = (objednavka) => {
        window.open(`${serverContextPath}/api/cgo/objednavka/${objednavka.id}/tiskKalkulace`, "_blank");
    };

    handleTiskDoklad = (objednavka) => {
        window.open(`${serverContextPath}/api/cgo/objednavka/${objednavka.id}/tiskFinalDoklad`, "_blank");
    };

    handleZmenitStav = (stav) => {
        const {objednavka, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('order.state_change'),
                t('order.state_change_prompt', {orderNumber: objednavka.cisloObjednavka, newState: EnumStavObjednavkaInfo.getCaption(stav, t)}),
                () => {
                    this.props.dispatch(modal.ModalActions.showAsyncWaiting(
                        t('please_wait'),
                        <Loader>{t('order.state_change_in_progress')}</Loader>,
                        ObjednavkaApi.updateObjednavkaStav(objednavka.id, stav), akceResult => {
                            this.props.dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                            this.props.dispatch(objednavkaActions.invalidateObjednavkaRights(objednavka.id));
                            this.props.dispatch(objednavkaActions.invalidateObjednavky());
                            this.props.dispatch(objednavkaActions.invalidateObjednavkyPrehled());
                            objednavkaActions.notifyIfNeeded(akceResult);
                        }
                    ));
                },
                null,
                t('confirm')
            )
        );
    };

    handlePreraditNaPobocku = (pobocka) => {
        const {objednavka, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('order.move_to_branch'),
                t('order.move_to_branch_prompt', {orderNumber: objednavka.cisloObjednavka, newBranch: pobocka.nazevPobocka}),
                () => {
                    ObjednavkaApi.updateObjednavkaPobocka(objednavka.id, pobocka.id).then(akceResult => {
                        this.props.dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                        objednavkaActions.notifyIfNeeded(akceResult);
                    });
                },
                null,
                t('order.move_action')
            )
        );
    };

    renderActions = () => {
        const {loggedInUser, objednavka, objednavkaRights, pobockyList, t} = this.props;
        let stavy = [];
        if (objednavkaRights.zmenaStavPovoleneVpred && objednavkaRights.zmenaStavPovoleneVpred.length > 0) {
            stavy = [...objednavkaRights.zmenaStavPovoleneVpred];
        }
        if (objednavkaRights.zmenaStavPovoleneZpet && objednavkaRights.zmenaStavPovoleneZpet.length > 0) {
            stavy = [...stavy, ...objednavkaRights.zmenaStavPovoleneZpet];
        }
        if (objednavkaRights.zmenaStavPovoleneStorno) {
            stavy.push(EnumStavObjednavka.STORN);
        }
        const canChangeStav = stavy && stavy.length > 0;
        const canPresunoutNaPobocku = loggedInUser.data.rgObjednavPresunPobocka;
        let tiskTool;
        const tiskRightsCount = [objednavkaRights.tiskObjednavka, objednavkaRights.tiskKalkulace, objednavkaRights.tiskFinalDoklad].filter(x => x).length;
        if (tiskRightsCount > 1) {
            tiskTool = <FixedDropDownButton noCaret title={<span>{t('order.print')} <Icon icon="caret-down"/></span>}>
                {objednavkaRights.tiskObjednavka && <DropdownItem onClick={this.handleTiskObjednavky.bind(this, objednavka)}>{t('order.print_order')}</DropdownItem>}
                {objednavkaRights.tiskKalkulace && <DropdownItem onClick={this.handleTiskKalkulace.bind(this, objednavka)}>{t('order.print_calculation')}</DropdownItem>}
                {objednavkaRights.tiskFinalDoklad && <DropdownItem onClick={this.handleTiskDoklad.bind(this, objednavka)}>{t('order.print_invoice')}</DropdownItem>}
            </FixedDropDownButton>;
        } else {
            tiskTool = <div>
                {objednavkaRights.tiskObjednavka && <Button onClick={this.handleTiskObjednavky.bind(this, objednavka)}>{t('order.print_order')}</Button>}
                {objednavkaRights.tiskKalkulace && <Button onClick={this.handleTiskKalkulace.bind(this, objednavka)}>{t('order.print_calculation')}</Button>}
                {objednavkaRights.tiskFinalDoklad && <Button onClick={this.handleTiskDoklad.bind(this, objednavka)}>{t('order.print_invoice')}</Button>}
            </div>;
        }
        return <ButtonToolbar>
            {tiskTool}
            {canChangeStav && <FixedDropDownButton noCaret title={<span>{t('change_state')} <Icon icon="caret-down"/></span>}>
                {stavy.map((stav, index) => <DropdownItem key={index} onClick={this.handleZmenitStav.bind(this, stav)}>{EnumStavObjednavkaInfo.getCaption(stav, t)}</DropdownItem>)}
            </FixedDropDownButton>}
            {canPresunoutNaPobocku && <FixedDropDownButton noCaret title={<span>{t('order.move_to_branch_action')} <Icon icon="caret-down"/></span>}>
                {pobockyList.rows.filter(p => p.id !== objednavka.pobockaId).map((pobocka, index) => <DropdownItem key={index} onClick={this.handlePreraditNaPobocku.bind(this, pobocka)}>{pobocka.nazevPobocka}</DropdownItem>)}
            </FixedDropDownButton>}
        </ButtonToolbar>
    };

    render() {
        const {loggedInUser, pobockyList, t} = this.props;
        if (!loggedInUser.fetched || loggedInUser.isFetching || !pobockyList.fetched || pobockyList.isFetching) {
            return <Loader/>;
        }

        const objednavka = this.props.objednavka;
        const posledniZmena = objednavka.objednavkaZmenaList && objednavka.objednavkaZmenaList.length > 0 ? objednavka.objednavkaZmenaList.reduce((prev, curr) => prev.datumZmena > curr.datumZmena ? prev : curr) : null;
        const posledniZmenaDatum = posledniZmena ? formatDateTime(posledniZmena.datumZmena) : null;
        const zpracovavaPobocka = objednavka.pobockaId && pobockyList.rows.find(p => p.id === objednavka.pobockaId);

        return <Card>
            <CardHeader>
                <ActionsRow actions={this.renderActions()}>
                    <h2>{t('basic_information')}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col xs={3}>
                        <DetailValue label={t('state')}><StavObjednavka stav={objednavka.stavObjednavka}/></DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue label={t('order.date_created')}>{formatDateTime(objednavka.datumZapis)}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue label={t('order.date_last_change')}>{posledniZmenaDatum}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue label={t('order.processing_branch')}>{zpracovavaPobocka && zpracovavaPobocka.nazevPobocka}</DetailValue>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        pobockyList: utils.storeFromArea(state, ciselnikActions.POBOCKY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(ZakladniInformacePanel));
